module.exports = __webpack_public_path__ + "bm.8f695fc2022c9871bcc4.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/vendors/flag-icon/flags/1x1/bm.svg
// module id = ../../../../../src/assets/vendors/flag-icon/flags/1x1/bm.svg
// module chunks = 0